import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { combineLatest, from, Observable, of } from 'rxjs';
import { first, map, mergeMap, switchMap } from 'rxjs/operators';
import { Drug } from 'src/API';
import { SideEffectFlaggingService } from './side-effect-flagging.service';

@Pipe({
  name: 'sideEffects'
})
export class SideEffectsPipe implements PipeTransform {
    private sideEffectsFriendlyNameMap = {
    dryEyes: 'Dry Eyes',
    glaucoma: 'Glaucoma',
    maculopathy: 'Maculopathy',
    opticNeuritis: 'Optic Neuritis/Neuropathy'
  };
  constructor(
    private service: SideEffectFlaggingService,
    private translocoService: TranslocoService
  ) {}

  transform(medication: Drug | Drug[]): Observable<string> {
    if (Array.isArray(medication)) {
      if (medication.length <= 0) {
        return of('');
      }
      return from(medication as Drug[]).pipe(
        mergeMap(medicine => this.transform(medicine)),
        first(sideEffects => !!sideEffects, '')
      );
    } else {
      return this.service.getSideEffects(medication as Drug).pipe(
        switchMap(sideEffects => {
          const activeEffects = Object.entries(sideEffects)
            .filter(([_, value]) => value)
            .map(([key]) => key);

          if (activeEffects.length === 0) {
            return of('');
          }

          // Create observables for each translation that update on language changes
          const translationObservables = activeEffects.map(effectKey =>
            this.translocoService.selectTranslate(`sideEffects.${effectKey}`)
          );

          // Combine all translations and update when any change
          return combineLatest(translationObservables).pipe(
            map(translatedEffects => translatedEffects.join(', '))
          );
        })
      );
    }
  }
}
